
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  colorLabelAlpineWhite: {
    id: "ColorLabel.alpinewhite",
    defaultMessage: "Alpine white (standard)",
  }, 
  colorLabelAlpineWhiteText: {
    id: "ColorLabel.alpinewhitetext",
    defaultMessage: "Temperature resistant up to 80° C",
  }, 
  colorLabelGraniteBlack: {
    id: "ColorLabel.graniteblack",
    defaultMessage: "Granite Black",
  }, 
  colorLabelGraniteBlackText: {
    id: "ColorLabel.graniteblacktext",
    defaultMessage: "Temperature resistant up to 65° C",
  }, 
  colorLabelGraniteBlackWhite: {
    id: "ColorLabel.graniteblackwhite",
    defaultMessage: "Granite Black-White",
  }, 
  colorLabelGraniteBlackWhiteText: {
    id: "ColorLabel.graniteblackwhitetext",
    defaultMessage: "Temperature resistant up to 65° C",
  }, 
  colorLabelGraniteLightGray: {
    id: "ColorLabel.graniteLightGray",
    defaultMessage: "Granite light Gray",
  }, 
  colorLabelGraniteLightGrayText: {
    id: "ColorLabel.granitelightgraytext",
    defaultMessage: "Temperature resistant up to 65° C",
  }, 
  colorBottomSideUncoated: {
    id: "ColorBottomSideUncoated.uncoated",
    defaultMessage: "uncoated (Standard)",
  },
  colorBottomSideGelcoat: {
    id: "ColorBottomSideGelcoat.gelcoat",
    defaultMessage: "Gelcoat",
  },
  colorBottomSideHint: {
    id: "ColorBottomSideHint.hint",
    defaultMessage: "Note: ",
  },
  colorBottomSideMessage: {
    id: "ColorBottomSideMessage.message",
    defaultMessage: "Advantages and recommendations for use",
  },
});

export default MESSAGES;